import Line from "components/layout/line";
import View from "components/layout/view";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { sharedDoGetListEntities } from "services/shared/list-entity";
import { useList } from "stores/hooks/list";
import { useListUser } from "stores/hooks/list-user";
import { useLocale } from "stores/hooks/locale";
import SingleBlock from "./single";
import MultiBlock from "./multi";
import BackButton from "components/navigation/back";
import Panel from "components/layout/panel";
import Footer from "views/shared/footer";
import Header from "views/shared/header";
import { useTranslate } from "stores/hooks/translation";

const SharedListUserView: FunctionComponent = () => {
  const translate = useTranslate();
  const list = useList();
  const user = useListUser();
  const locale = useLocale();
  const [listEntities, toggleListEntities] = useState<ListEntity[]>([]);

  const update = async () => {
    if (list) {
      const listEntities = await sharedDoGetListEntities(list);
      toggleListEntities(listEntities);
    }
  };

  useEffect(() => {
    if (list) {
      // update list user
      update();
    }
  }, [list]);

  if (!list || !user) {
    return null;
  }

  const listTitle = parse(list.name, locale);
  const userTitle = [user.firstname, user.lastname].join(" ");
  const title = [listTitle, userTitle].join(", ");

  return (
    <View title={title} navigation={false}>
      <Panel>
        <Header title={title}></Header>
        <BackButton>{translate("go_back")}</BackButton>
        {listEntities.map((listEntity, index) => {
          return (
            <Fragment key={listEntity.uuid}>
              {!listEntity.multi && (
                <SingleBlock
                  listUuid={list.uuid}
                  listUserUuid={user.uuid}
                  listEntity={listEntity}
                />
              )}
              {listEntity.multi && <MultiBlock listEntity={listEntity} />}
              {index < listEntities.length - 1 && <Line />}
            </Fragment>
          );
        })}
      </Panel>
      <Footer />
    </View>
  );
};

export default SharedListUserView;
